export const isWindowReadonly = () => window.name === "windowReadonly";

export const getModelIdByRiskTolerance = riskTolerance => {
  if (!riskTolerance) return null;

  riskTolerance = riskTolerance.toLowerCase();

  if (riskTolerance === "growth") return 71;
  if (riskTolerance === "preservation") return 72;
  if (riskTolerance === "conservative") return 73;
  if (riskTolerance === "moderate") return 74;
  if (riskTolerance === "aggressive") return 75;
};

export const getRiskToleranceByRiskScore = riskScore => {
  if (riskScore <= 20) return "Preservation";
  if (riskScore <= 40) return "Conservative";
  if (riskScore <= 60) return "Moderate";
  if (riskScore <= 80) return "Growth";
  return "Aggressive";
};
